<div class="container">
  <div class="header-container">
    <h1 i18n="@@suggestions.page.title">Term Suggestions</h1>
    <div class="filter-container">
      <mat-form-field appearance="outline" subscriptSizing="dynamic" class="status-filter">
        <mat-label i18n="@@suggestions.filter.status">Status</mat-label>
        <mat-select [value]="statusFilter" (selectionChange)="onStatusFilterChange($event.value)">
          <mat-option value="PENDING" i18n="@@suggestions.status.pending">Pending</mat-option>
          <mat-option value="APPROVED" i18n="@@suggestions.status.approved">Approved</mat-option>
          <mat-option value="DENIED" i18n="@@suggestions.status.denied">Denied</mat-option>
          <mat-option value="ALL" i18n="@@suggestions.status.all">All</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  @if (suggestions.length === 0) {
    <p class="no-data" i18n="@@suggestions.no.data">No suggestions found.</p>
  }

  @if (suggestions.length > 0) {
    <table mat-table [dataSource]="suggestions" class="mat-elevation-z8">

      <ng-container matColumnDef="termName">
        <th mat-header-cell *matHeaderCellDef i18n="@@suggestions.column.termName">Term Name</th>
        <td mat-cell *matCellDef="let s">{{ s.termName }}</td>
      </ng-container>

      <ng-container matColumnDef="languageCode">
        <th mat-header-cell *matHeaderCellDef i18n="@@suggestions.column.language">Language</th>
        <td mat-cell *matCellDef="let s">{{ s.languageCode }}</td>
      </ng-container>

      <ng-container matColumnDef="dictionary">
        <th mat-header-cell *matHeaderCellDef i18n="@@suggestions.column.dictionary">Dictionary</th>
        <td mat-cell *matCellDef="let s">{{ dictionaryName(s) }}</td>
      </ng-container>

      <ng-container matColumnDef="submitterName">
        <th mat-header-cell *matHeaderCellDef i18n="@@suggestions.column.submittedBy">Submitted By</th>
        <td mat-cell *matCellDef="let s">{{ s.submitterName }}</td>
      </ng-container>

      <ng-container matColumnDef="createdAt">
        <th mat-header-cell *matHeaderCellDef i18n="@@suggestions.column.date">Date</th>
        <td mat-cell *matCellDef="let s">{{ s.createdAt | date: 'yyyy-MM-dd HH:mm' }}</td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef i18n="@@suggestions.column.status">Status</th>
        <td mat-cell *matCellDef="let s">
          <span class="status-cell">
            <span class="status-badge" [class]="'status-' + s.status.toLowerCase()">{{ s.status }}</span>
            @if (s.sendFailed) {
              <mat-icon class="send-failed-icon" [matTooltip]="s.sendFailedReason || sendFailedTooltip">warning</mat-icon>
            }
            @if (s.reviewComment) {
              <span class="review-comment" [matTooltip]="s.reviewComment">
                <mat-icon class="comment-icon">comment</mat-icon>
              </span>
            }
          </span>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"
          [class.clickable]="canReview(row)"
          (click)="onRowClick(row)"></tr>
    </table>
  }
</div>
